/**
 * 会员权益类型（type 字段）
 */
export enum BenefitType {
  FREE_GENERATION = 1, // 免费生图
  AVATAR_FRAME = 2, // 头像框
  HD_DOWNLOAD = 3, // 图片高清下载
  EXPOSURE = 4, // 作品曝光
  SPEED_BOOST = 5, // 速度提升
  NICKNAME = 6, // 昵称
  EXCLUSIVE_STYLE = 7, // 专属风格包
  MULTI_IMAGE = 8, // 多图输出
  DATA_PACKAGE = 9, // 流量包
  OTHER = 0, // 其它
}

/**
 * 类型限制（typeLimit 字段）
 */
export enum TypeLimit {
  FREE_GENERATION_COUNT = 1, // 免费生图张数
  AVATAR_FRAME_URL = 2, // 头像框地址
  HD_DOWNLOAD_COUNT = 3, // 图片高清下载次数
  EXPOSURE_PERCENTAGE = 4, // 作品曝光百分比
  SPEED_BOOST_COUNT = 5, // 速度提升张数
  NICKNAME_EFFECT = 6, // 昵称效果
  EXCLUSIVE_STYLE_PACK = 7, // 专属风格包（可以不填）
  MULTI_IMAGE_OUTPUT = 8, // 多图输出
  OTHER = 0, // 其它
}

/**
 * 搜索表单数据
 */
export interface BenefitSearchParams {
  currentPage?: number;
  pageSize?: number;
}

/**
 * 会员权益记录（API 响应）
 */
export interface BenefitRecord {
  id: number;
  titleEn: string;
  titleJa: string;
  obtainContentEn: string;
  obtainContentJa: string;
  iconUrl: string; // 会员权益图标
  typeLimit: string; // 类型限制
  type: number; // 类型ID（从接口获取）
  link: string;
  status: number; // 状态
  showOrder?: number; // 排序值
  // benefitAvatarFram?: number[]; // 会员头像框（Checkbox 选择）
  // benefitAvatar?: number | number[]; // 会员头像框（Select 选择）
  nicknameColor?: string; // 会员昵称效果
  likeAnimation?: string; // 会员点赞动效
  downloadCount?: number | string; // 赠币/无水印下载数量
  increasedExposure?: number | string; // 曝光提升
  speedIncrease?: number | string; // 速度提升
  groupKey?: string; // E15: 权益分组标识（同类权益相同key，用于对比表横向对齐）
  groupCategory?: string; // E15: 权益大类（coins/create/trade/exclusive）
  corePrivilege?: number; // E15: 是否核心权益（1=订阅页展示，0=仅对比表展示）
  createTime: string;
  createUserId: number;
  createUserName: string;
  updateTime: string;
  updateUserId: number;
  updateUserName: string;
}

/**
 * API 分页响应
 */
export interface BenefitListApiResponse {
  status: number;
  success: boolean;
  message: string;
  data: {
    total: number;
    currentPage: number;
    pageSize: number;
    records: BenefitRecord[];
  };
}

/**
 * API 详情响应
 */
export interface BenefitDetailApiResponse {
  status: number;
  success: boolean;
  message: string;
  data: BenefitRecord;
}

/**
 * 分页响应（内部使用）
 */
export interface BenefitListResponse {
  records: BenefitRecord[];
  total: number;
  currentPage: number;
  pageSize: number;
}

/**
 * 会员权益表单数据
 */
export interface BenefitFormData {
  titleEn: string; // 会员权益名称（英文）
  titleJa: string; // 会员权益名称（日文）
  iconUrl: string; // 会员权益图标
  type: number; // 会员权益类型ID（从接口获取）
  obtainContentEn: string; // 权益获取文案（英文）
  obtainContentJa: string; // 权益获取文案（日文）
  // benefitAvatarFram?: number[]; // 会员头像框（Checkbox 选择），存储 productStockId 数组
  // benefitAvatar?: number | number[]; // 会员头像框（Select 选择），支持单选或多选
  nicknameColor?: string; // 会员昵称效果（仅用于 NICKNAME 类型）
  likeAnimation?: string; // 会员点赞动效
  typeLimit?: string; // 类型限制（根据 type 不同，存储不同的值，统一为字符串类型）
  link?: string; // 跳转页面
  status?: number; // 启用状态（0: 禁用, 1: 启用）
  showOrder?: number; // 排序值
  groupKey?: string; // E15: 权益分组标识
  groupCategory?: string; // E15: 权益大类（coins/create/trade/exclusive）
  corePrivilege?: number; // E15: 是否核心权益（1=订阅页展示）
}

/**
 * 头像框选项（扩展 ProductStock）
 */
export interface AvatarFrameOption {
  productStockId: number;
  avatarFrameImage?: string;
  productDesc?: string;
  productTitle: string;
  categoryTitle: string;
}

/**
 * 会员权益类型选项（用于下拉选择）
 */
export interface BenefitTypeOption {
  id: number; // 权益类型ID
  name: string; // 权益类型名称
  limitStatus?: number; // 限制状态：0-不显示，1-显示InputNumber，2-显示会员昵称效果
  limitDesc?: string; // typeLimit字段的标签
  [key: string]: any;
}
